module.exports = __webpack_public_path__ + "static/media/amela-admin.ac4c564a.svg";